module.exports = __webpack_public_path__ + "static/media/HoneyJar.45b75b5a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/HoneyJar.png
// module id = 249
// module chunks = 0